export default "__VITE_ASSET__CtaZ$Jdd__"